import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import _ from "underscore";
import { onBeforeUnmount, onMounted, watch, ref, computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'modal',
  props: {
  value: { type: Object, required: false, default: () => {} },
  visible: { type: Boolean, default: false },
  overlay: { type: Boolean, default: true },
  centered: { type: Boolean, default: true },
  className: { type: String, default: "" },
  closeOnBackdropClick: { type: Boolean, default: true },
  overflowYScroll: { type: Boolean, default: true },
  fieldFocus: { type: Object, required: false, default: () => {} },
  borderRadius: { type: String, default: "6px" },
  overflowYVisible: { type: Boolean, default: false },
  isHideOverlay: { type: Boolean, default: true },
  styleModal: { type: String, default: "" },
  closeOnEsc: { type: Boolean, default: true },
  overflow: { type: Boolean, default: false },
  shouldScrollToBottom: { type: Boolean, default: false },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "58a55786": (overflowYScrollModalMain.value)
}))

const inputField = ref(null);
let initialValue = {};


/**
 * Need get/set all initial "value" before "visible" = true
 * Because functions check close on click backdrop will not work.
 */


const handleVisible = () => {
  if (!props.overlay) return;
  if (props.visible) {
    setTimeout(() => {
      const modal: any = document.getElementById("modalGlobal");
      const inputForm: any = document.getElementsByClassName("autoFocus");
      const isInsideModal = Array.from(inputForm).every((el) =>
        modal.contains(el),
      );
      if (
        inputForm &&
        inputForm.length > 0 &&
        !props.shouldScrollToBottom &&
        isInsideModal
      ) {
        inputForm[0].focus();
      }
    }, 100);

    initialValue = JSON.stringify(props.value);
    store.dispatch("Overlay/showOverlay");

    // Watch event when modal is visible.
    EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ESC, () => {
      if (props.closeOnEsc) emit("close");
    });
    EventEmitter.on(EmitterEvents.EVENT_SWITCH_ORG, () => emit("close"));

    // Only Watch if closeOnBackdropClick === TRUE.
    if (!props.closeOnBackdropClick) return;

    window.addEventListener("click", (e: any) => {
      if (
        _.isEqual(initialValue, JSON.stringify(props.value)) &&
        e.target.id === "globalOverlay"
      )
        emit("close");
    });
  } else {
    destroyModal();
  }
  setTimeout(() => {
    EventEmitter.emit("setZIndexIConNavBar", true);
    if (props.visible) {
      EventEmitter.emit("setZIndexIConNavBar", true);
    } else {
      EventEmitter.emit("setZIndexIConNavBar", false);
    }
  }, 0);
};

const destroyModal = () => {
  initialValue = {};
  if (props.isHideOverlay) {
    store.dispatch("Overlay/hideOverlay");
  }
  if (props.isHideOverlay) {
    EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ESC);
  }
  EventEmitter.off(EmitterEvents.EVENT_SWITCH_ORG);

  if (props.closeOnBackdropClick) window.removeEventListener("click", () => {});
};

const overflowYScrollModalMain = computed(() => {
  return props.overflowYScroll ? "auto" : "none";
});

onMounted(() => {
  handleVisible();
});
onBeforeUnmount(() => destroyModal());
watch(() => props.visible, handleVisible);

return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "modalGlobal",
        ref_key: "inputField",
        ref: inputField,
        class: _normalizeClass(`tw-w-[97%] ${
      __props.centered
        ? 'tw-z-[1071] tw-fixed top-of-modal tw-left-2/4 tw-translate-x-[-50%] tw-translate-y-[-50%]'
        : 'tw-relative'
    } tw-max-w-[1040px] tw-justify-center tw-items-center modal-wrapper  ${__props.className} ${
      __props.overflow ? 'modal-wrapper-profile' : ''
    }`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`tw-relative tw-bg-white lg:tw-overflow-y-hidden ${
        __props.overflowYScroll ? '!tw-overflow-y-auto' : ''
      } ${
        __props.overflowYVisible ? '!tw-overflow-y-visible' : ''
      } tw-w-full tw-flex tw-flex-col tw-rounded-[6px] tw-max-w-[100%] modal-main ${__props.styleModal}`),
          style: _normalizeStyle({
        borderRadius: __props.borderRadius,
      })
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 6)
      ], 2))
    : _createCommentVNode("", true)
}
}

})